module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('static.producers.add')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _c('v-form', {
    attrs: {
      "save": _vm.save,
      "form": _vm.form,
      "hasLabel": true,
      "translation": "form.producers"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1e1b73","hasScoped":false}!./src/app/components/addProducer/addProducer.html
// module id = 3002
// module chunks = 1